import React  from 'react';
import './App.css';
import { useNavigate } from "react-router-dom";

class ChangeLogListToolbar extends React.Component {

	constructor(props) {

		super(props);
		
		this.handleSelectLink = this.handleSelectLink.bind(this);
		this.renderLink = this.renderLink.bind(this);
	}
	
	handleSelectLink(page) {		
		const navigate = this.props.navigate;
  		navigate(page);
	}
	
	renderLink(renderYN, linkTitle, linkValue) {
		
		if (!renderYN) {
			return;
		}

		var classNameString = "ChangeLogListToolbarLink";
		
		return (
			<div 
				className={classNameString}
				onClick={() => this.handleSelectLink(linkValue)}
			>
				{linkTitle}
			</div>
		);
	}
	
	render() {

		var modelName = this.props.modelName;
		//var chatAppUserType = this.props.chatAppUserType;
		
		return (
			<div className="ChangeLogListToolbarContainer1">
				<div className="ChangeLogListToolbarLeft">
					<div 
						className="ChangeLogListToolbarLink"
						onClick={() => this.handleSelectLink("/selectmodel")}
					>
						{modelName}
					</div>
				</div>
				<div className="ChangeLogListToolbarRight">
				</div>
			</div>
		);
	}
}

export default function ChangeLogListToolbarFunction(props) {
	const navigate = useNavigate();
	return <ChangeLogListToolbar {...props} navigate={navigate} />;
}

